/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Regex {
    getFixupPrototypeFunction() { return Regex.fixupPrototype; }

    static newInstance(model: Partial<Regex>): Regex {
        let obj = Object.assign(new Regex(), model);
        Regex.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Regex>): Regex {
        if (!model) return null;
        return Regex.newInstance(<Regex> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Regex) {
        if (!obj) return;

        models.Regex.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Regex): boolean {
        Object.setPrototypeOf(obj, Regex.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Regex pattern to match against
     */
    pattern: string;

    /**
     * Ignore case when matching
     */
    ignore_case: boolean;

    /**
     * Type of pattern matching operation
     */
    op: models.RegexQueryCondition;

}
